const THEME_MODE = Object.freeze({
  dark: 'dark',
  light: 'light',
  bright: 'bright',
});

// noinspection JSUnusedGlobalSymbols
export default THEME_MODE;
